﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";
import {loaderShow, loaderHide} from "./loader";
import {applyVatPrices} from "./vat-toggle";

export function initAddToCart() {
    let productContainer = $(".product-container:not(.without-price)");
    if (productContainer.length) {
        let colourInput = productContainer.find('input[name="ColourId"]');
        let quantityInput = productContainer.find('input[name="Quantity"]');


        if (colourInput.length && quantityInput.length) {
            $(colourInput).on("change", function () {
                validateQuantityData(quantityInput);
            });

            $(quantityInput).on("change", function () {
                validateQuantityData(quantityInput);
            });

            quantityInput.on('keyup keypress', function (e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    $(this).trigger('change');
                    return false;
                }
            });

            validateQuantityData(quantityInput);
        }
    }
}

function validateQuantityData(quantityInput) {

    if (quantityInput.length) {
        let quantity = quantityInput.val();
        let quantityMin = quantityInput.attr("min") ?? "0";

        if (parseInt(quantity) < parseInt(quantityMin)) {
            quantity = quantityMin;
            quantityInput.val(quantity);
        }

        let productVariantId = quantityInput.data("pricing-info");
        
        if (productVariantId) {
            let pricingSteps = quantityInput.data("pricing-steps");
            
            fetch(`/Product/GetPriceInfo?productVariantId=${productVariantId}&quantity=${quantity}`)
                .then(response => response.json())
                .then(response => {
                        let pricingQuantity = $('.product-price [data-pricing-quantity]');
                        if (pricingQuantity?.length) {
                            let isLowestQuantity = true;
                            
                            if (pricingSteps?.length){
                                if (pricingSteps[0]!=response?.pricingQuantity){
                                    isLowestQuantity = false;
                                }
                            }
                            
                            if (isLowestQuantity){
                                pricingQuantity.html(response?.pricingQuantity);
                            }
                            else{
                                pricingQuantity.html(`order ${pricingSteps[0]}. Price from ${response?.pricingQuantity} is`)
                            }
                        }

                        let pricingUnitPrice = $('.product-price [data-pricing-unitprice]');
                        if (pricingUnitPrice?.length) {
                            pricingUnitPrice.data('vat-ex', response?.unitPrice);
                            pricingUnitPrice.data('vat-inc', response?.unitPriceIncVat);
                        }

                        let pricingTotalUnitPrice = $('.product-price [data-pricing-unitprice-total]');
                        if (pricingTotalUnitPrice?.length) {
                            pricingTotalUnitPrice.data('vat-ex', response?.subTotal);
                            pricingTotalUnitPrice.data('vat-inc', response?.grandTotal);
                        }

                        if (pricingUnitPrice || pricingTotalUnitPrice) {
                            applyVatPrices(pricingUnitPrice.closest('.product-price'));
                        }
                    }
                );
        }
    }
}

export function initQuantity() {
    //checkout delivery "same as billing"
    // let deliveryForm = document.getElementById("deliveryForm");
    // let checkBox = document.getElementById("checkBilling");
    // deliveryForm.style.display = checkBox.checked ? "none" : "block";

    //product quantity input
    let deIncrement = document.getElementsByClassName("btn-minus");
    let increment = document.getElementsByClassName("btn-plus");
    let number = document.getElementById("inputQuantity");

    if (number && increment.length && deIncrement.length) {
        let pricingSteps = JSON.parse(number.dataset.pricingSteps);

        let step = 1;
        let max = 9999;
        let min = parseInt(document.getElementById("inputQuantity").getAttribute("min")) ?? 0;

        number.oninput = function () {
            number.value = number.value > 9999 ? 9999 : number.value < 0 ? 0 : number.value;
        };

        number.onchange = function () {
            let initValue = parseInt(number.value);
            number.value = initValue > 9999 ? 9999 : initValue < min ? min : initValue;

            validateQuantityData($(number));
        };

        increment[0].addEventListener("click", () => {
            let currentValue = parseInt(number.value);
            let nextTarget = pricingSteps?.filter(f=>f > currentValue);
            if (nextTarget?.length){
                number.value = nextTarget[0];
                validateQuantityData($(number));
                return;
            }
            
            if (parseInt(number.value) + step >= max) {
                number.value = max;
                validateQuantityData($(number));
                return;
            }

            number.value = parseInt(number.value) + step;
            validateQuantityData($(number));
            

        }, false);


        deIncrement[0].addEventListener("click", () => {
            let currentValue = parseInt(number.value);
            let nextTarget = pricingSteps?.filter(f=>f < currentValue);
            if (nextTarget?.length){
                number.value = nextTarget[nextTarget.length - 1];
                validateQuantityData($(number));
                return;
            }

            if (parseInt(number.value) - step <= min) {
                number.value = min;
                validateQuantityData($(number));
                return;
            }

            number.value = parseInt(number.value) - step;
            validateQuantityData($(number));
            

        }, false);
    }
}